import { z } from "zod";

// CoreAPI sends decimals as strings
const decimal = z.union([z.string(), z.number()]).nullable().optional();

const material = z.object({
    name: z.string().nullable().optional(),
    manufacturer: z.string().nullable().optional(),
    imageUrlSmall: z.string().nullable().optional()
}).nullable().optional();

// GET …/apartments/{apartmentId}?bundles=true&rooms=true&elements=true. Only the fields the bundle inspector needs.
// Elements are only returned nested in rooms, and only when they belong to a bundle (one entry per bundle).
// Most bundle fields are only present when the user can see selection properties.
export const coreApartmentBundlesSchema = z.object({
    data: z.object({
        bundles: z.array(z.object({
            id: z.number(),
            name: z.string().nullable().optional(),
            userCanSeeBundle: z.boolean().optional(),
            amount: decimal,                                    // In amountUnit, a unit id (pcs, m2, cm…)
            amountUnit: z.string().nullable().optional(),
            description: z.string().nullable().optional(),
            status: z.string().nullable().optional(),
            state: z.string().nullable().optional(),             // Selection state: OPEN, LOCKED, CONFIRMED…
            cost: decimal,                                      // Gross, including VAT
            hasPrice: z.boolean().optional(),
            selectedMaterial: material,
            isApartmentLevel: z.boolean().nullable().optional(),
            roomIds: z.array(z.number()).nullable().optional()    // One room for a room-level bundle, several or none for apartment level
        })).optional(),
        rooms: z.array(z.object({
            id: z.number(),
            name: z.string().nullable().optional(),
            elements: z.array(z.object({
                id: z.number(),                                 // The room element's id, what CoreAPI's bundle endpoints take
                name: z.string().nullable().optional(),
                globalId: z.string().nullable().optional(),
                bundleId: z.number().nullable().optional()
            })).optional()
        })).optional()
    })
});
